'use strict';
/* eslint no-unused-vars: 0 */
const React = require('react');
const Router = require('react-router');
const Route = Router.Route;

const RootHandler						= require('./components/RootHandler');
const ArticleHandler				= require('./components/ArticleHandler');
const FirstpageHandler			= require('./components/FirstpageHandler');
const ProgramHandler				= require('./components/ProgramHandler');
const ProgramListHandler		= require('./components/ProgramListHandler');
const StyleGuidePageHandler	= require('./components/StyleGuideHandler');
const NotFoundLegacyHandler	= require('./components/NotFoundHandler/NotFoundLegacyComponent.jsx');
const PageHandler						= require('./components/PageHandler');
const NotFoundHandler				= require('./components/NotFoundHandler');

module.exports = (
	<Route component={RootHandler}>
		<Route path="/program" component={ProgramListHandler}/>
		<Route path="/program/*" component={NotFoundLegacyHandler}/>
		<Route name="/styleguide" path="styleguide" component={StyleGuidePageHandler}/>
		<Route component={PageHandler}>
			<Route path="/" component={FirstpageHandler}/>
			<Route path=":program" component={ProgramHandler}/>
			<Route path=":program/:article" component={ArticleHandler}/>
			<Route path="*" component={NotFoundHandler} />
		</Route>
	</Route>
);



/** WEBPACK FOOTER **
 ** ./app/routes.js
 **/